import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

const root = document.getElementById("root")!;
const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

// Detect if page was prerendered (SSG) by checking for existing content
const hasPrerenderedContent = root.innerHTML.trim().length > 0;

if (import.meta.env.PROD && hasPrerenderedContent) {
  // SSG mode: Hydrate the prerendered HTML
  hydrateRoot(root, app);
} else {
  // CSR mode: Render fresh (dev mode or CSR build)
  createRoot(root).render(app);
}
